/**
 * Detección de plataforma para el banner de descarga de la app (card 687).
 *
 * Va por user agent y NO por ancho de ventana a propósito: un desktop con la
 * ventana angosta no puede instalar la app, ofrecerle descargarla es ruido.
 * Además hace falta saber la plataforma igual, para elegir a qué store mandarlo.
 */

export const STORE_URLS = {
  ios: "https://apps.apple.com/ar/app/drapp-pro/id1568156396",
  // Link directo, no el wrapper de play.app.goo.gl: los dominios de dynamic
  // links de Google se apagaron.
  android: "https://play.google.com/store/apps/details?id=la.drapp.app",
};

/** @returns {"ios" | "android" | null} */
const getPlatform = () => {
  const ua = navigator.userAgent || "";

  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";

  // iPadOS 13+ se reporta como "Macintosh" en el user agent — sin este caso los
  // iPad quedarían afuera, que es justo la mitad del "tablet" que pide la card.
  // maxTouchPoints es lo que lo distingue de una Mac de escritorio.
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return "ios";

  // Sin filtrar por "Mobile": cubre teléfono y tablet Android, que también
  // entra en el alcance.
  if (/Android/i.test(ua)) return "android";

  return null;
};

export default getPlatform;
